module.exports = __webpack_public_path__ + "media/country_flags/aw-011eec7a.png";